export const SALES_PIPELINE_STAGE_IDS = [
  "first_contact",
  "qualification",
  "vehicle_interest",
  "visit_test_drive",
  "proposal_sent",
  "negotiation",
  "proposal_approved",
  "payment",
  "sale_confirmed",
  "preparation",
  "delivery",
] as const;

export type SalesPipelineStageId = (typeof SALES_PIPELINE_STAGE_IDS)[number];
